import React from 'react';

const WithdrawalModal = ({ 
    isOpen, 
    onClose, 
    onConfirmWithdrawal, 
    onStayInPool, 
    cancelText, 
    cancelOutroText,
    title,
    description,
    confirmLabel,
    secondaryLabel,
    showSecondary = true,
    icon = 'warning',
    children
}) => {
    if (!isOpen) return null;

    const resolvedTitle = title || 'Bewerbung zurückziehen?';
    const resolvedDescription = description || cancelText || "Du hast gemerkt, dass wir vielleicht nicht die richtige Passung sind? Kein Problem — das ist für beide Seiten wichtig! Hier kannst du uns einfach mitteilen, dass du deine Bewerbung zurückziehen möchtest.";
    const resolvedConfirmLabel = confirmLabel || 'Absage bestätigen';
    const resolvedSecondaryLabel = secondaryLabel || 'Ich möchte bleiben!';
    const shouldShowSecondaryAction = showSecondary && typeof onStayInPool === 'function';
    const iconStyles = icon === 'info'
      ? {
          wrapper: 'bg-blue-100 dark:bg-blue-900/30',
          color: 'text-blue-600 dark:text-blue-400',
          path: (
            <>
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M12 22a10 10 0 110-20 10 10 0 010 20z" />
            </>
          )
        }
      : {
          wrapper: 'bg-orange-100 dark:bg-orange-900/30',
          color: 'text-orange-600 dark:text-orange-400',
          path: (
            <>
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </>
          )
        };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white dark:bg-slate-800 rounded-xl p-6 max-w-md w-full shadow-xl">
                <div className="text-center mb-6">
                    <div className={`w-16 h-16 ${iconStyles.wrapper} rounded-full flex items-center justify-center mx-auto mb-4`}>
                        <svg className={`w-8 h-8 ${iconStyles.color}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            {iconStyles.path}
                        </svg>
                    </div>
                    <h3 className="text-xl font-semibold text-slate-800 dark:text-slate-100 mb-2">
                        {resolvedTitle}
                    </h3>
                    <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
                        {resolvedDescription}
                    </p>
                    {children}
                </div>

                <div className="flex flex-col gap-3">
                    <button
                        onClick={onConfirmWithdrawal}
                        className="w-full px-4 py-3 bg-red-600 text-white font-medium rounded-lg hover:bg-red-700 transition-colors"
                    >
                        {resolvedConfirmLabel}
                    </button>
                    {shouldShowSecondaryAction && (
                        <button
                            onClick={onStayInPool}
                            className="w-full px-4 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors"
                        >
                            {resolvedSecondaryLabel}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default WithdrawalModal;
